import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import '../../styles/index.css';
import '../public/LandingPage.css';
import './Login.css';

const Login = () => {
    const [selectedUser, setSelectedUser] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const { login, loginWithGoogle } = useAuth();
    const navigate = useNavigate();

    // Predefined test users
    const testUsers = [];
    //     { email: 'admin@tce.edu', role: 'Admin', name: 'Dr. Admin Kumar' },
    //     { email: 'dean@tce.edu', role: 'Dean', name: 'Dr. Dean Sharma' },
    //     { email: 'hod.cse@tce.edu', role: 'HOD', name: 'Dr. Rajesh Kumar' },
    //     { email: 'dlc1@tce.edu', role: 'DLC', name: 'Dr. Suresh Babu' },
    //     { email: 'supervisor1@tce.edu', role: 'Supervisor', name: 'Dr. Venkat Raman' },
    //     { email: 'scholar1@tce.edu', role: 'Scholar', name: 'Arun Kumar' },
    //     { email: 'scholar2@tce.edu', role: 'Scholar', name: 'Priya Sharma' }
    // ];

    const handleUserSelect = (e) => {
        const selected = e.target.value;
        setSelectedUser(selected);
        setEmail(selected);
        setPassword('password123');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            const user = await login(email, password);

            // Check if user needs to change password first
            if (user.mustChangePassword) {
                navigate('/change-password');
                return;
            }

            // Redirect based on role
            switch (user.role) {
                case 'scholar':
                    navigate('/scholar/dashboard');
                    break;
                case 'supervisor':
                    navigate('/supervisor/dashboard');
                    break;
                case 'dlc':
                    navigate('/dlc/dashboard');
                    break;
                case 'hod':
                    navigate('/hod/dashboard');
                    break;
                case 'dean':
                    navigate('/dean/dashboard');
                    break;
                case 'admin':
                    navigate('/admin/dashboard');
                    break;
                default:
                    navigate('/');
            }
        } catch (err) {
            console.error('Login error:', err);
            setError(err.message || 'Login failed. Please check your credentials.');
        } finally {
            setLoading(false);
        }
    };

    const handleGoogleSignIn = async () => {
        setError('');
        setLoading(true);

        try {
            const user = await loginWithGoogle();

            // Redirect based on role
            switch (user.role) {
                case 'scholar':
                    navigate('/scholar/dashboard');
                    break;
                case 'supervisor':
                    navigate('/supervisor/dashboard');
                    break;
                case 'dlc':
                    navigate('/dlc/dashboard');
                    break;
                case 'hod':
                    navigate('/hod/dashboard');
                    break;
                case 'dean':
                    navigate('/dean/dashboard');
                    break;
                case 'admin':
                    navigate('/admin/dashboard');
                    break;
                default:
                    navigate('/');
            }
        } catch (err) {
            console.error('Google Sign In error:', err);
            setError(err.message || 'Failed to sign in with Google.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-page-wrapper">
            {/* Header */}
            <header className="landing-header">

                <div className="header-container">
                    <div className="logo-section">
                        <img src="/lareg_logo.png" alt="TCE Logo" className="tce-logo" />
                    </div>

                    <nav className="header-nav">
                        <a href="/" className="nav-link">Home</a>
                        <a href="/home#about" onClick={(e) => { e.preventDefault(); window.location.href = '/home#about'; }} className="nav-link">About TRF</a>
                        <a href="/home#eligibility" onClick={(e) => { e.preventDefault(); window.location.href = '/home#eligibility'; }} className="nav-link">Eligibility</a>
                        <a href="/home#guidelines" onClick={(e) => { e.preventDefault(); window.location.href = '/home#guidelines'; }} className="nav-link">Guidelines</a>
                        <a href="#footer" className="nav-link">Contact</a>
                        <button onClick={() => navigate('/login')} className="login-btn">
                            Login
                        </button>
                    </nav>
                </div>
            </header>

            {/* Login Form Section */}
            <div className="login-content">
                <div className="login-card">
                    <div className="login-header">
                        <h1 className="login-title">TRF Login</h1>

                    </div>

                    {error && (
                        <div className="login-error">
                            {error}
                        </div>
                    )}

                    {/* Google Sign In Section */}
                    <div className="form-section">
                        <button
                            type="button"
                            onClick={handleGoogleSignIn}
                            disabled={loading}
                            className="google-signin-btn"
                        >
                            <svg width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4" />
                                <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" />
                                <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05" />
                                <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" />
                            </svg>
                            {loading ? 'Signing in...' : 'Sign in with Google'}
                        </button>
                    </div>

                    <div className="section-divider">OR</div>

                    {/* Login Form */}
                    <form onSubmit={handleSubmit}>


                        <div className="login-form-group">
                            <label className="login-form-label">Email Address</label>
                            <div className="input-with-icon">
                                <svg className="input-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3 8L10.89 13.26C11.2187 13.4793 11.6049 13.5963 12 13.5963C12.3951 13.5963 12.7813 13.4793 13.11 13.26L21 8M5 19H19C19.5304 19 20.0391 18.7893 20.4142 18.4142C20.7893 18.0391 21 17.5304 21 17V7C21 6.46957 20.7893 5.96086 20.4142 5.58579C20.0391 5.21071 19.5304 5 19 5H5C4.46957 5 3.96086 5.21071 3.58579 5.58579C3.21071 5.96086 3 6.46957 3 7V17C3 17.5304 3.21071 18.0391 3.58579 18.4142C3.96086 18.7893 4.46957 19 5 19Z" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                <input
                                    type="email"
                                    className="login-form-input with-icon"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                    placeholder="Enter your email"
                                />
                            </div>
                        </div>

                        <div className="login-form-group">
                            <div className="label-row">
                                <label className="login-form-label">Password</label>
                                <a href="/reset-password" className="forgot-password-link">Forgot Password?</a>
                            </div>
                            <div className="input-with-icon">
                                <svg className="input-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M16 8V6C16 4.93913 15.5786 3.92172 14.8284 3.17157C14.0783 2.42143 13.0609 2 12 2C10.9391 2 9.92172 2.42143 9.17157 3.17157C8.42143 3.92172 8 4.93913 8 6V8M5 10C4.46957 10 3.96086 10.2107 3.58579 10.5858C3.21071 10.9609 3 11.4696 3 12V19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V12C21 11.4696 20.7893 10.9609 20.4142 10.5858C20.0391 10.2107 19.5304 10 19 10H5Z" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                <input
                                    type="password"
                                    className="login-form-input with-icon"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                    placeholder="Enter your password"
                                />
                            </div>
                        </div>

                        <button
                            type="submit"
                            disabled={loading}
                            className="login-submit-btn"
                        >
                            {loading ? 'Signing in...' : 'Sign In'}
                        </button>
                    </form>
                </div>
            </div>

            {/* Footer */}
            <footer id="footer" className="landing-footer">
                <div className="footer-container">
                    <div className="footer-content">
                        <div className="footer-section">
                            <h4>Thiagarajar College of Engineering</h4>
                            <p>Madurai - 625 015, Tamil Nadu, India</p>
                        </div>
                        <div className="footer-section">
                            <h4>Contact</h4>
                            <p>Email: <a href="mailto:research@tce.edu">research@tce.edu</a></p>
                            <p>Phone: <a href="tel:+914522482240">+91 452 2482240</a></p>
                            <p>Web: <a href="https://www.tce.edu" target="_blank" rel="noopener noreferrer">www.tce.edu</a></p>
                        </div>
                        <div className="footer-section">
                            <h4>Quick Links</h4>
                            <p><a href="/">Home</a></p>
                            <p><a href="/#about">About TRF</a></p>
                            <p><a href="/#eligibility">Eligibility</a></p>
                            <p><a href="/#guidelines">Guidelines</a></p>
                        </div>
                    </div>
                    <div className="footer-bottom">
                        <p>Copyright © 2026 Thiagarajar College of Engineering. All Rights Reserved.</p>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default Login;
